export const TEXT = {
  HEADING: 'TOKEN_EXPIRE_MODAL_HEADING',
  CONTENT: 'TOKEN_EXPIRE_MODAL_CONTENT',
  CTA: 'TOKEN_EXPIRE_MODAL_CTA',
} as const;

export const PARAMS = {
  DISMISS_TIME_MINUTE: 3,
  ONE_MINUTE_IN_SECONDS: 60000,
};
